<script setup lang="ts">
type Props = {
  src?: string;
  provider?: string;
  fallback?: string;
  // 読み込み中アニメーション
  loadingAnimation?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  fallback: "/images/fallback_image.png",
  loadingAnimation: false,
});

const imgRef = ref<{ $el: HTMLImageElement } | null>(null);

// 一度目のエラーでproviderを外す
// それでもエラーならフォールバック画像に
const errorCount = ref(0);

const isError = computed(() => {
  return errorCount.value >= 2;
});

const attrs = useAttrs();

const modifiers = {
  gravity: attrs.gravity,
  resize: attrs.resize,
  crop: attrs.crop,
  enlarge: attrs.enlarge ?? "",
};

// 読み込み完了フラグ
// 読み込み中アニメーションをするか?
const isLoaded = ref(props.loadingAnimation && !attrs.preload ? false : true);
if (props.loadingAnimation) {
  // 読み込み完了後のアニメーション
  // 透明度を0から1に変化させフェードインする

  // 2秒後に読み込み完了フラグを立てる
  setTimeout(() => {
    isLoaded.value = true;
  }, 2000);

  watch(
    () => isLoaded.value,
    (bool) => {
      if (!bool) return;

      const img = imgRef.value;

      const { finish } = useAnimate(
        img?.$el,
        [{ opacity: 0 }, { opacity: 1 }],
        {
          duration: 500,
          direction: "alternate",
          easing: "cubic-bezier(0.46, 0.03, 0.52, 0.96)",
        },
      );
    },
    {
      immediate: true,
    },
  );
}
</script>

<template>
  <NuxtImg
    ref="imgRef"
    class="nuxt-img"
    :class="{
      loading: !isLoaded,
    }"
    :provider="!errorCount ? provider : ''"
    :src="isError ? fallback : src"
    @error="errorCount += 1"
    @load.native="isLoaded = true"
    :modifiers="modifiers"
  />
</template>

<style>
/** alt属性のテキストを調整 */
.nuxt-img {
  color: #aaa;
  font-size: 12px;
}

/* 読み込み中　背景を点滅させる */
.loading {
  animation: blink-loading-img 1.5s infinite;
  background-color: #888;
}
@keyframes blink-loading-img {
  0% {
    opacity: 0.2;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 0.2;
  }
}
</style>
